import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type PaginatedResponse } from './types'
import { type ProspectEmployee } from '../prospects/types'

export function useGetProspectEmployees ({
  prospectId,
  censusId,
  pagination,
  enabled = true,
}: {
  prospectId: string;
  censusId: string;
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
  enabled?: boolean;
}) {
  return useQuery<PaginatedResponse<ProspectEmployee>, GrapeAPIErrorType>({
    queryKey: [
      'quoting',
      'prospects',
      prospectId,
      'census',
      censusId,
      'pagination',
      pagination,
    ],
    queryFn: async () => {
      const queryParams: Record<string, any> = {
        'page[number]': pagination.pageIndex.toString(),
        'page[size]': pagination.pageSize.toString(),
      }
      const queryString = new URLSearchParams(queryParams).toString()
      const url =
        '/api/web/quoting/prospects/' +
        prospectId +
        '/census/' +
        censusId +
        '/employees?' +
        queryString
      const response = await fetchWithHeaders(url)
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    enabled,
  })
}
